module.exports = __webpack_public_path__ + "8ac8ebf30231b891ea37f646cc6342e5.ttf";